<ng-container [ngSwitch]="item.type">
  <fgbcl-auction-panel
    *ngSwitchCase="'auction'"
    [auctionItem]="item.data"
    [ignoreLink]="ignoreLink"
    [featuredIcon]="featuredIcon"
  ></fgbcl-auction-panel>

  <ng-container *ngSwitchCase="'marketplace'">
    @switch (version.marketplace) {
      @case (2) {
        <fgbcl-marketplace-list-item-v2
          [marketplaceItem]="item.data"
          [ignoreLink]="ignoreLink"
          [featuredIcon]="featuredIcon"
        ></fgbcl-marketplace-list-item-v2>
      }
      @default {
        <fgbcl-marketplace-list-item
          [marketplaceItem]="item.data"
          [ignoreLink]="ignoreLink"
          [featuredIcon]="featuredIcon"
        ></fgbcl-marketplace-list-item>
      }
    }
  </ng-container>

  <ng-container *ngSwitchCase="'lotto'">
    @switch (version.lotto) {
      @case (2) {
        <fgbcl-lottos-list-item-v2
          [lottoItem]="item.data"
          [ignoreLink]="ignoreLink"
          [featuredIcon]="featuredIcon"
        ></fgbcl-lottos-list-item-v2>
      }
      @default {
        <fgbcl-lottos-list-item
          [lottoItem]="item.data"
          [ignoreLink]="ignoreLink"
          [featuredIcon]="featuredIcon"
        ></fgbcl-lottos-list-item>
      }
    }
  </ng-container>
</ng-container>
